import jwtDecode from 'jwt-decode'
import _ from 'lodash'
import { createSelector } from 'reselect'

import { RootState } from '../types'

import { AdminxVisibilityOption, ContractType, TokenPayload } from './types'

const selectState = (state: RootState) => state.user

export const getToken = createSelector(selectState, s => s.token)

export const getDecodedToken = createSelector(getToken, t => (t ? (jwtDecode(t) as TokenPayload) : null))

export const isUserLoggedIn = createSelector(selectState, s => !!s.token)

export const getFullName = createSelector(getDecodedToken, t =>
  t ? `${t['admx.firstname'] || ''} ${t['admx.lastname'] || ''}` : ''
)

export const getUserEmail = createSelector(getDecodedToken, t => (t ? t['admx.email'] : ''))

export const getName = createSelector(getDecodedToken, t => (t ? t['admx.firstname'] : ''))

export const getSurname = createSelector(getDecodedToken, t => (t ? t['admx.lastname'] : ''))

export const getUsername = createSelector(getDecodedToken, t => (t ? t['admx.username'] : ''))

export const getRegistrationChannel = createSelector(getDecodedToken, t => (t ? t['admx.registration-channel'] : ''))

export const getPaymentOptionCode = createSelector(getDecodedToken, t => (t ? t['admx.payment-option'] : ''))

export const getSubscriberId = createSelector(getDecodedToken, t => (t ? t['admx.subscriberid'] : ''))

export const getSubscriberExternalId = createSelector(getDecodedToken, t =>
  t ? t['admx.subscriber-external-code'] : ''
)

export const getUserId = createSelector(getDecodedToken, t => (t ? t['admx.userid'] : ''))

export const getAdminxUserId = createSelector(getDecodedToken, t => (t ? t['admx.adminxuserid'] : ''))

export const getAdminxVisibilityOption = createSelector(getDecodedToken, t =>
  t ? t['admx.visibility'] : AdminxVisibilityOption.ReportVisibilityUser
)

export const getContractType = createSelector(getDecodedToken, t =>
  t ? t['admx.contract-type'] : ContractType.PayperClick
)

export const canSeePrices = createSelector(getDecodedToken, t =>
  t ? _.toLower(t['admx.show-price-off']) == 'false' : true
)

export const getUserHash = createSelector(getDecodedToken, t => t?.['admx.user-hash'])

export const getInvalidContractDetected = createSelector(selectState, s => s.invalidContractDetected)

export const getInvalidContractConfirmed = createSelector(selectState, s => s.invalidContractConfirmed)

export const getSessionTimeoutDetected = createSelector(selectState, s => s.sessionTimeoutDetected)

export const getSessionTimeoutConfirmed = createSelector(selectState, s => s.sessionTimeoutConfirmed)

export const getUserRoles = createSelector(getDecodedToken, t =>
  t ? t['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] : []
)

export const getLoginAsRoles = createSelector(getDecodedToken, t => (t ? t['admx.login-as-roles'] : []))

export const isProbeUser = createSelector(getDecodedToken, t => (t ? _.toLower(t['admx.is-probe']) == 'true' : false))

export const getLoginAsUserName = createSelector(getDecodedToken, t => t?.['admx.login-as-username'])

export const getPreferedLanguage = createSelector(getDecodedToken, t =>
  t ? t['admx.language'].toLocaleLowerCase() : ''
)
